import { cn } from '$components'
import { ElementType, Fragment, ReactNode } from 'react'
import { NavLink } from 'react-router-dom'
import { Text } from '$components'

export type NavigationLinkProps = {
  to: string,
  children?: ReactNode,
  icon: ElementType,
  onClick?: () => void,
}

export function NavigationLink({ to, children, icon: Icon, onClick }: NavigationLinkProps) {

  return (
    <NavLink
      to={to}
      onClick={onClick}
      className={({ isActive }) => cn(
        'flex gap-2 p-3 items-center rounded-2xl',
        {
          'bg-gray-900 text-white': isActive,
          'hover:bg-gray-100 text-gray-900': !isActive,
        },
      )}
    >
      {({ isActive }) => (
        <Fragment>
          <Icon className={cn(
            'size-[20px] min-w-[20px] min-h-[20px]',
            {
              'text-white': isActive,
            },
          )}
          />

          <Text className={cn(
            'truncate text-sm',
            {
              'text-white': isActive,
            },
          )}
          >
            { children }
          </Text>
        </Fragment>
      )}
    </NavLink>
  )
}
